module.exports = __webpack_public_path__ + "img/elxz1.eeb84362.jpg";